import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes = [
  {
    path: '/menu',
    redirect: '/theme', // 默认重定向到主页
    component: () => import('@/views/menu_view.vue'), // 布局组件（包含侧边栏）
    children: [ // 所有需要侧边栏的路由作为子路由
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/HomeView.vue')
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user_manage.vue')
      },
      {
        path: '/adminuser',
        name: 'adminuser',
        component: () => import('@/views/admin_user_manage.vue')
      },
      {
        path: '/resource',
        name: 'resource',
        component: () => import('@/views/pic_item_manage.vue')
      },
      {
        path: '/theme',
        name: 'theme',
        component: () => import('@/views/theme_view.vue')
      },
    ]
  },
  // 不需要侧边栏的独立路由（如登录页）
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/log_view.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
